// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"97cdad49","419":"6b2ca44b","465":"ad43a4a1","602":"bdc1e57a","709":"e56cdb32","991":"198c6401"}[chunkId] + ".chunk.js";
};